import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-organisations-container',
  templateUrl: './organisations-container.component.html',
  styleUrls: ['./organisations-container.component.scss'],
})
export class OrganisationsContainerComponent {}
